import styled from 'styled-components';
import { theme } from '../../../../styles/theme';

export const Container = styled.div`
  width: 100%;
  overflow-x: auto;
  text-align: left;
`;
export const Table = styled.table`
  width: 100%;
  border: 1px solid ${theme.colors.border};
  border-collapse: collapse;
  th,
  td {
    border: 1px solid ${theme.colors.border};
    border-collapse: collapse;
  }
`;
export const HeaderCell = styled.th`
  height: 48px;
  padding: 7px 8px;
  background-color: ${theme.colors.tableHeader};
  font-size: 14px;
  font-weight: 600;
  color: ${theme.colors.secondary900};
`;
export const BodyCell = styled.td`
  padding: 7px 8px;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.5;
  color: ${theme.colors.secondary800};
  vertical-align: top;
`;
export const Label = styled.span`
  display: inline-block;
  margin-right: 3px;
  font-weight: 600;
  color: ${theme.colors.secondary900};
`;
export const VariantName = styled.div`
  margin-bottom: 8px;
  font-weight: 600;
`;
